var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ChangePassword"},[_c('div',{staticClass:"btn"},[_c('div',{staticClass:"confirmBnt bg-color-red",on:{"click":_vm.confirm}},[_vm._v("返回首页")])])])}
var staticRenderFns = []

export { render, staticRenderFns }